export default function AboutSection() {
  return (
    <section id="about" className="py-16 md:py-24 bg-background-50 scroll-mt-20">
      <div className="mx-auto max-w-6xl px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 md:gap-10 items-center">
          <div className="relative rounded-2xl overflow-hidden h-72 md:h-[420px]">
            <img
              src="https://readdy.ai/api/search-image?query=editorial%20magazine%20editorial%20desk%20with%20research%20notes%2C%20printed%20timeline%20charts%20and%20cuttings%2C%20warm%20ambient%20desk%20lamp%20light%2C%20warm%20paper%20and%20ink%20tones%2C%20minimal%20cozy%20workspace&width=1200&height=900&seq=about-office-41&orientation=portrait"
              alt="四一爆料编辑部工作台"
              className="absolute inset-0 w-full h-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-background-950/40 to-transparent"></div>
          </div>

          <div>
            <span className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs font-semibold tracking-wide whitespace-nowrap">
              <i className="ri-honour-line"></i>
              关于四一爆料
            </span>
            <h2 className="font-heading text-2xl md:text-4xl font-black text-foreground-950 mt-4 leading-snug">
              我们做的事很简单：把散落的信息重新排好序
            </h2>
            <p className="mt-4 text-foreground-600 text-sm md:text-base leading-relaxed">
              当热点来得太快、信息散落在各处时，最容易被错过的恰恰是完整的"来龙去脉"。四一爆料的初心，就是把公开讨论过的话题按时间先后重新梳理，让后来的读者也能从零看懂一条脉络。
            </p>
            <p className="mt-3 text-foreground-600 text-sm md:text-base leading-relaxed">
              我们不追一时之快，更在乎整理的完整与准确：每个节点标注时间、每个系列持续沉淀、每条脉络可以回看。三年时间线、六大系列，都建立在"先还原事实顺序，再提供浏览便利"这一原则上。
            </p>

            <div className="mt-6 flex flex-wrap gap-4">
              {[
                { icon: "ri-search-eye-line", t: "注重脉络" },
                { icon: "ri-file-chart-line", t: "讲求依据" },
                { icon: "ri-community-line", t: "开放共创" },
              ].map((f) => (
                <div
                  key={f.t}
                  className="flex items-center gap-2 px-4 py-2.5 rounded-lg bg-background-100 border border-background-200"
                >
                  <i className={`${f.icon} text-primary-600 text-base`}></i>
                  <span className="text-sm font-semibold text-foreground-800">{f.t}</span>
                </div>
              ))}
            </div>

            <blockquote className="mt-6 border-l-4 border-accent-400 pl-4">
              <p className="text-sm md:text-base text-foreground-700 italic leading-relaxed">
                "每一条能被后人补课的脉络，都值得被认真排一次队。" —— 四一爆料编辑部
              </p>
            </blockquote>
          </div>
        </div>

        <div className="mt-10 grid grid-cols-1 sm:grid-cols-3 gap-4 md:gap-5">
          {[
            { q: "按时间归档", d: "每条内容标注所属年份与月份，脉络清晰可回溯。" },
            { q: "系列化沉淀", d: "同类话题归于同一系列，长期更新不断累积。" },
            { q: "开放纠错", d: "发现顺序或细节出入可随时反馈，编辑部核对后修正。" },
          ].map((v) => (
            <div key={v.q} className="rounded-xl bg-background-100 border border-background-200 p-5">
              <div className="flex items-center gap-2">
                <i className="ri-checkbox-circle-line text-primary-500 text-lg"></i>
                <h3 className="text-base font-bold text-foreground-950">{v.q}</h3>
              </div>
              <p className="mt-2 text-sm text-foreground-600 leading-relaxed">{v.d}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}